import { apiV3RegistriesPath } from 'lib/urls'
import fetch from 'lib/fetch'
import { parseErrors } from 'lib/api-utils'
import { REGISTRY_ROLES } from 'registry/constants'
import {
  apiV3PostSignupEcommercePath,
  apiV3RegistryPath,
  apiV3UserPath,
} from '../../../../lib/urls'

export const signup = (data) => {
  return fetch(apiV3RegistriesPath, {
    body: JSON.stringify(data),
    method: 'POST',
  }).catch((resp) => Promise.reject(parseErrors(resp)))
}

export const addProductsToRegistry = (registryId, products) => {
  return fetch(`${apiV3RegistriesPath}/${registryId}/reg_items`, {
    body: JSON.stringify({ reg_items: products }),
    method: 'POST',
  })
}

export const addPartner = ({ registry, partner }) =>
  fetch(apiV3RegistryPath(registry.id), {
    body: JSON.stringify({
      regenerateUrlSlug: true,
      registry: {
        family: {
          partner,
        },
      },
    }),
    method: 'PATCH',
  }).catch((resp) => Promise.reject(parseErrors(resp)))

export const convertPartnerToCollaborator = ({ registry, partner }) =>
  fetch(apiV3RegistryPath(registry.id), {
    body: JSON.stringify({
      registry: {
        collaborators: [{ ...partner, role: REGISTRY_ROLES.PARTNER }],
        family: {
          partner,
        },
      },
    }),
    method: 'PATCH',
  }).catch((resp) => Promise.reject(parseErrors(resp)))

export const finishingTouches = ({ registryId, partner, collaborator }) => {
  const family = {
    hasPartner: false,
  }
  const collaborators = []
  if (partner) {
    family.hasPartner = true
    family.partner = partner

    if (partner.email) {
      collaborators.push({ ...partner, role: REGISTRY_ROLES.PARTNER })
    }
  }
  if (collaborator)
    collaborators.push({ ...collaborator, role: REGISTRY_ROLES.COLLABORATOR })

  return fetch(apiV3RegistryPath(registryId), {
    body: JSON.stringify({
      registry: {
        collaborators,
        family,
      },
    }),
    method: 'PATCH',
  }).catch((resp) => Promise.reject(parseErrors(resp)))
}

export const saveHasPartner = ({ registry, hasPartner }) =>
  fetch(apiV3RegistryPath(registry.id), {
    body: JSON.stringify({
      registry: {
        family: {
          hasPartner,
        },
      },
    }),
    method: 'PATCH',
  }).catch((resp) => Promise.reject(parseErrors(resp)))

export const saveUser = (user) =>
  fetch(apiV3UserPath, {
    body: JSON.stringify({ user }),
    method: 'PATCH',
  }).catch((resp) => Promise.reject(parseErrors(resp)))

export const getPostSignupEcommerce = () =>
  fetch(apiV3PostSignupEcommercePath, {
    method: 'GET',
  }).catch((resp) => Promise.reject(parseErrors(resp)))
